// import { getMagicCraftNfts } from 'subgraph/utils';
import {
  getMagicCraftNfts,
  getMagicCraftListedNfts,
  getMagicCraftAccountWithNfts,
} from 'api/utils';
import { getNftContractAddress } from 'state/nftMarketplace';

export const fetchAccountMagicNfts = async (
  pageNumber: number,
  account: string,
  rarity?: string[],
) => {
  const contractAddress = getNftContractAddress();
  let inventoryNfts: any[] = [];

  const val = localStorage.getItem('filterlist');

  let fieldType;
  let tempFilter;

  if (val === 'Highest Price First') {
    fieldType = 'startingPrice';
    tempFilter = -1;
  } else if (val === 'Lowest Price First') {
    fieldType = 'startingPrice';
    tempFilter = 1;
  } else if (val === 'Latest First') {
    fieldType = 'startAt';
    tempFilter = -1;
  } else {
    fieldType = 'startingPrice';
    tempFilter = -1;
  }

  try {
    inventoryNfts = [
      ...(await getMagicCraftAccountWithNfts(
        pageNumber,
        fieldType,
        process.env.REACT_APP_GENESIS_CONTRACT_ADDRESS || '',
        tempFilter,
        account.toLowerCase(),
        rarity,
      )),
    ];
  } catch (error) {
    inventoryNfts = [];
  }

  return {
    inventoryNfts,
  };
};

export const fetchMagicNfts = async (
  pageNumber: number,
  rarity?: string[],
  latestCall?: boolean,
) => {
  const contractAddress = getNftContractAddress();
  let listedNfts: any[] = [];

  const val = localStorage.getItem('filterlist');

  let fieldType;
  let tempFilter;

  if (!latestCall) {
    if (val === 'Highest Price First') {
      fieldType = 'startingPrice';
      tempFilter = -1;
    } else if (val === 'Lowest Price First') {
      fieldType = 'startingPrice';
      tempFilter = 1;
    } else if (val === 'Latest First') {
      fieldType = 'startAt';
      tempFilter = -1;
    } else {
      fieldType = 'startingPrice';
      tempFilter = -1;
    }
  } else {
    fieldType = 'startAt';
    tempFilter = -1;
  }

  try {
    listedNfts = await getMagicCraftListedNfts(
      pageNumber,
      fieldType,
      contractAddress,
      tempFilter,
      rarity,
    );
  } catch (error) {
    listedNfts = [];
  }

  let nftMetadata: any[] = [];

  try {
    nftMetadata = await getMagicCraftNfts(
      contractAddress,
      listedNfts.map((it: any) => it.tokenID),
    );
  } catch (error) {
    nftMetadata = [];
  }

  if (listedNfts.length) {
    listedNfts = listedNfts.map((item, i) => {
      const metadata = nftMetadata.find(
        (it) => String(it?.tokenID) === String(item?.tokenID),
      );
      return {
        ...item,
        contractAddress,
        name: metadata ? metadata.name : (item.name ?? `NFT #${item?.tokenID ?? i}`),
        description: metadata ? metadata.description : (item.description ?? ''),
        image: metadata ? (metadata.image ?? '') : (item.image ?? ''),
        attributes: metadata?.attributes ? [...metadata.attributes] : (item.attributes ?? []),
      };
    });
  }

  return {
    listedNfts,
  };
};

export const fetchNftInfo = async (
  tokenId: string,
  contractAddress: string,
) => {
  let inventoryNft: any = {};

  try {
    inventoryNft = contractAddress
      ? await getMagicCraftNfts(contractAddress, [tokenId])
      : [];
  } catch (error) {
    inventoryNft = {};
  }

  return {
    selectedNft: inventoryNft.length > 0 ? inventoryNft[0] : null,
  };
};
